import {Repository, createRepository} from '@/repositories/Base/Repository'

class VnsCommandRepository extends Repository {
    endpoint = 'integration/vns/equipment/send'

    updateBridge(params) {
        return this.$axios.post(`${this.endpoint}/update/bridge`, params)

    }

    updateMonitor(params) {
        return this.$axios.post(`${this.endpoint}/update/monitor`, params)
    }

    updateTransfer(params) {
        return this.$axios.post(`${this.endpoint}/update/transfer`, params)
    }

    sendAction(params) {
        return this.$axios.post(`${this.endpoint}/action/tovns`, params)
    }

    sendCommand(params) {
        return this.$axios.post(`${this.endpoint}/command/tovns`, params)
    }
}

export default new VnsCommandRepository()

export const create = createRepository(VnsCommandRepository)
